document.addEventListener('alpine:init', () => {
  function announcementBar(data = {}) {
    return {
      ...data,

      onFormSubmit() {
        var fetchUrl = `${this.$el.action}.js`;
  
        var fetchOptions = {
          method: this.$el.method,
          body: new FormData(this.$el)
        };
  
        fetch(fetchUrl, fetchOptions).catch((err) => {
          console.log(err);
        });

        this.$root.remove();
      }
    };
  };

  Alpine.data('announcementBar', announcementBar);
});
 